import React from 'react'
import Breadcrumb from '../Breadcrumb/Breadcrumb'
import ContactForm from './ContactForm'
import contactBanner from '../../asset/homefour/contact.webp';
const Contact = () => {
  return (
    <div>
        <Breadcrumb bannerImage={contactBanner} currentPage="Contact" />
        <ContactForm />
    </div>
  )
}

export default Contact